import React from "react";
import { useTranslation } from "react-i18next";
import DashboardSidebarMenu from "../../components/controls/DashboardSideBarMenu";
import { getProviderMenus } from "../../contexts/ProviderMenus";

function ProviderDashboard() {
  const { t } = useTranslation();
  const title = t("navbar.provider");
  const menus = getProviderMenus();

  return (
    <div className="flex">
      {/* Sidebar */}
      <DashboardSidebarMenu title={title} menus={menus} />

      {/* Main Content */}
      <div className="flex-1 p-6 text-onWhite">
        <h1>{t("providers.dashboardDescription")}</h1>
      </div>
    </div>
  );
}

export default ProviderDashboard;
